import { useMemo } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { isEqual } from "lodash";
import { ruleFormSchema, RuleFormType } from "../validation/ruleFormSchema";

function useVersionRuleForm(defaultValues: RuleFormType) {
  const methods = useForm({
    resolver: zodResolver(ruleFormSchema),
    defaultValues,
    mode: "onChange",
  });
  const formValues = methods.watch();
  const isFormChanged = useMemo(() => {
    return !isEqual(formValues, defaultValues);
  }, [formValues, defaultValues]);
  return { methods, isFormChanged };
}

export default useVersionRuleForm;
